import { createContext } from "react";

const Scroll_Context = createContext();

export default Scroll_Context;